import React from 'react';

import PropTypes from 'prop-types';

export const featModem = ({ fillColor }) => (
    <svg viewBox='0 0 94 59' xmlns='http://www.w3.org/2000/svg'>
        <g fill={fillColor} transform='translate(-86 -361)'>
            <path d='M164.095 382.01h-60.4v-20.944H99.79v21.076c-7.74.95-13.757 7.604-13.757 15.635V420h93.707v-22.223c0-8.72-7.026-15.766-15.645-15.766zm11.742 34.024h-85.9v-18.29c0-6.523 5.268-11.833 11.74-11.833h62.45c6.473 0 11.742 5.31 11.742 11.834v18.29h-.033zm-27.03-10.292c-1.975 0-3.577-1.615-3.577-3.606 0-1.99 1.602-3.605 3.578-3.605 1.976 0 3.577 1.615 3.577 3.606 0 1.99-1.6 3.606-3.577 3.606zm-14.05 0c-1.977 0-3.578-1.615-3.578-3.606 0-1.99 1.6-3.605 3.576-3.605s3.578 1.615 3.578 3.606c0 1.99-1.602 3.606-3.578 3.606zm28.07 0c-1.977 0-3.58-1.615-3.58-3.606 0-1.99 1.603-3.605 3.58-3.605 1.975 0 3.577 1.615 3.577 3.606 0 1.99-1.602 3.606-3.578 3.606z' />
        </g>
    </svg>
);

featModem.propTypes = {
    fillColor: PropTypes.string.isRequired
};

export default featModem;
